import { current } from './config/language';

document.querySelector('#lang').value = current;
